import { render, staticRenderFns } from "./PanelAccountSettingsSet.vue?vue&type=template&id=3a0ed58c&scoped=true&"
import script from "./PanelAccountSettingsSet.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsSet.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsSet.vue?vue&type=style&index=0&id=3a0ed58c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ed58c",
  null
  
)

export default component.exports